import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import { urlRegMatch } from 'Helpers/urlService';

const AppSchema = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
    category: Yup.string().required($t('This value is required')),
    type: Yup.string().required($t('This value is required')),
    app_url: Yup.string().matches(urlRegMatch, $t('App Url must be a valid URL')).nullable(),
    redirect: Yup.string().matches(urlRegMatch, $t('App Url must be a valid URL')).nullable(),
});

export default function ApiClientsCreateForm(props) {
    return (
        <div>
            <Formik
                enableReinitialize
                initialValues={{
                    name: '',
                    category: props.defaultCategory,
                    type: props.defaultType,
                    app_url: '',
                    redirect: '',
                }}
                validationSchema={AppSchema}
                onSubmit={(values, actions) => {
                    props.onSubmit(values);
                    actions.resetForm();
                    actions.setSubmitting(false);
                }}
            >
                {({ errors, touched, isSubmitting, handleSubmit }) => (
                    <>
                        <div className="tw-flex tw-flex-row tw-my-3">
                            <label htmlFor="name" className="tw-basis-4/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                {$t('App Name')} <span className="tw-text-red-500">*</span>
                            </label>
                            <div className="tw-basis-8/12">
                                <Field
                                    type="text"
                                    className={errors.name && touched.name ? 'input text-input invalid' : 'input text-input'}
                                    placeholder={$t('App Name')}
                                    name="name"
                                />
                                {errors.name && touched.name && <div className="tw-text-red-500">{errors.name}</div>}
                            </div>
                        </div>

                        <div className="tw-flex tw-flex-row tw-my-3">
                            <label htmlFor="category" className="tw-basis-4/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                {$t('Integration Category')} <span className="tw-text-red-500">*</span>
                            </label>
                            <div className="tw-basis-8/12 tw-flex tw-flex-row">
                                {Object.keys(props.categories).map((categoryKey) => {
                                    return (
                                        <label key={categoryKey} className="input-checkbox__label tw-flex tw-items-center tw-gap-x-1.5 tw-pr-3">
                                            <Field type="radio" name="category" value={categoryKey} />
                                            {props.categories[categoryKey]}
                                        </label>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="tw-flex tw-flex-row tw-my-3">
                            <label htmlFor="type" className="tw-basis-4/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                {$t('Integration Type')} <span className="tw-text-red-500">*</span>
                            </label>
                            <div className="tw-basis-8/12 tw-flex tw-flex-row">
                                {Object.keys(props.types).map((typeKey) => {
                                    return (
                                        <label key={typeKey} className="input-checkbox__label tw-flex tw-items-center tw-gap-x-1.5 tw-pr-3">
                                            <Field type="radio" name="type" value={typeKey} />
                                            {props.types[typeKey]}
                                        </label>
                                    );
                                })}
                            </div>
                        </div>

                        <div className="tw-flex tw-flex-row tw-my-3">
                            <label htmlFor="app_url" className="tw-basis-4/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                {$t('App URL')}
                            </label>
                            <div className="tw-basis-8/12">
                                <Field
                                    type="text"
                                    className={errors.app_url && touched.app_url ? 'input text-input invalid' : 'input text-input'}
                                    placeholder={$t('App URL')}
                                    name="app_url"
                                />
                                {errors.app_url && touched.app_url && <div className="tw-text-red-500">{errors.app_url}</div>}
                            </div>
                        </div>

                        <div className="tw-flex tw-flex-row tw-my-3">
                            <label htmlFor="app_url" className="tw-basis-4/12 tw-font-bold" style={{ fontSize: '14px' }}>
                                {$t('Redirect URI')}
                            </label>
                            <div className="tw-basis-8/12">
                                <Field
                                    type="text"
                                    className={errors.redirect && touched.redirect ? 'input text-input invalid' : 'input text-input'}
                                    placeholder={$t('Redirect URI')}
                                    name="redirect"
                                />
                                {errors.redirect && touched.redirect && <div className="tw-text-red-500">{errors.redirect}</div>}
                            </div>
                        </div>

                        <div className="tw-flex tw-justify-end">
                            <button type="button" className={'button secondary tw-mr-2'} onClick={props.onClose}>
                                {$t('Cancel')}
                            </button>

                            <button type="button" className={'button primary'} disabled={isSubmitting ? true : false} onClick={handleSubmit}>
                                {$t('Submit')}
                            </button>
                        </div>
                    </>
                )}
            </Formik>
        </div>
    );
}
